exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.cellLinkType[data-v-7a970653] {\r\n  text-align: center;\n}\n.cursor-pointer[data-v-7a970653] {\r\n  cursor: pointer;\n}\n.cellLinkType a[data-v-7a970653] {\r\n  color: #35495e;\n}\n.cellLinkType div[active='true'][data-v-7a970653] .mdi-star {\r\n  color: #f4c129;\n}\r\n", ""]);

// exports
